.component {
  display: flex;
  align-items: center;
  padding: 2px $baseline-2;
  border-radius: $border-radius-large;
  color: $color-white;
  overflow: hidden;
  width: fit-content;
  margin: 2px 0;
  @include typo-headline-6;

  &.standard {
    border-color: $color-sc-navy;
    background-color: $color-sc-navy;
  }

  &.sales {
    background-color: $color-orchid;
  }

  &.new {
    @include gradient-1;
  }

  &.sales:where(.sdx--dark-theme) {
    background-color: $color-orchid-dark-theme;
  }

  &.dark,
  &.standard.sdx--dark-theme {
    padding: 1px $baseline-2;
    background: rgb($color-white, 0.1);
    border: 1px solid $color-white;
  }

  .icon {
    margin-right: $baseline * 0.5;
  }
}
